// 20.2.2.28 Math.sign(x)
var $export = require('./_export');

$export($export.S, 'Math', {sign: require('./_math-sign')});


//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/modules/es6.math.sign.js
// module id = 993
// module chunks = 0